import React, { useState } from "react";
import CustomModal from "../Model/CustomModal";
import ThankYouModal from "../Model/ThankYouModel";
import axios from "axios";
import moment from "moment";
import { InlineWidget } from "react-calendly";

const BrochureDownloadModal = ({ open, setClose }) => {
  const [thankYouModal, setThankYouModal] = useState(false);
  const [data, setData] = useState({});
  const [validation, setValidation] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = async () => {
    let flag = true;
    setLoading(true);
    let validate = {};
    const currentDate = new Date();
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Fullname validation

    console.log(data.name, "data.name");
    if (data.name?.length <= 0 || typeof data.name === "undefined") {
      flag = false;
      validate.name = "Name cannot be empty.";
    } else if (data?.name?.length < 3) {
      flag = false;
      validate.name = "Name must be at least 3 characters long.";
    } else if (!nameRegex?.test(data.name)) {
      flag = false;
      validate.name = "Name can only contain letters and spaces.";
    }

    // WhatsApp number validation
    if (
      data.phoneNumber?.length < 0 ||
      typeof data.phoneNumber === "undefined"
    ) {
      flag = false;
      validate.phoneNumber = "WhatsApp number cannot be empty.";
    } else if (!/^[6-9]/.test(data.phoneNumber)) {
      flag = false;
      validate.phoneNumber = "Invalid WhatsApp number";
    } else if (!/^\d{10}$/.test(data.phoneNumber)) {
      flag = false;
      validate.phoneNumber = "WhatsApp number must be exactly 10 digits.";
    }

    // Email validation
    if (data.emailId?.length < 0 || typeof data.emailId === "undefined") {
      flag = false;
      validate.emailId = "emailId cannot be empty.";
    } else if (!emailPattern.test(data.emailId)) {
      flag = false;
      validate.emailId = "Invalid emailId address.";
    }

    // City validation
    if (data.city?.length < 0 || typeof data.city === "undefined") {
      flag = false;
      validate.city = "City cannot be empty.";
    } else if (!nameRegex.test(data.city)) {
      flag = false;
      validate.city = "City can only contain letters and spaces.";
    }
    if (flag) {
      try {
        let inputValue = {
          Name: data.name,
          "Phone Number": data.phoneNumber,
          "Email Id": data.emailId,
          City: data.city,
          Date: moment(new Date()).format("DD/MMM/yyyy hh:mm:ss"),
        };

        // const Payload = [
        //   {
        //     Attribute: "FirstName",
        //     Value: data.name,
        //   },
        //   {
        //     Attribute: "EmailAddress",
        //     Value: data.emailId,
        //   },
        //   {
        //     Attribute: "Phone",
        //     Value: data.phoneNumber,
        //   },
        //   {
        //     Attribute: "City",
        //     Value: data.city,
        //   },
        //   {
        //     Attribute: "Source",
        //     Value: "Web-Academy-Download-Broucher",
        //   },
        // ];

        // try {
        //   const response = await axios.post(
        //     "https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.Capture?accessKey=u$r6bb21b3cf1518343d1981ce6646b844f&secretKey=d58ccce3a29496917e48f84d2f40d31061c6b781",

        //     Payload,
        //     {
        //       headers: {
        //         Accept: "application/json",
        //         "Content-Type": "application/json",
        //       },
        //     }
        //   );
        // } catch (e) {
        //   console.error("Error sending to Leadsquared:", e);
        // }

        let form_data = new FormData();
        for (let key in inputValue) {
          form_data.append(key, inputValue[key]);
        }
        const response = await fetch(
          // "https://script.google.com/macros/s/AKfycbxUBWxRdM5qzkoEuZyoqnfkSHgHZnbnO2jq-KrOTJAuFihVMN_5cBv0S9rGkoxfGSrw/exec",
          "https://script.google.com/macros/s/AKfycbwgnvLQvGp_NHn8wljmHjL39RRTLv_PHnWu5RJj4oqo2j6koV4_Evl2wXRvbbYRw9h5/exec",
          {
            method: "POST",
            body: form_data,
          }
        );

        await response.text();
        setLoading(false);
        setClose();
        setData({});
        setThankYouModal(true);
        window.open(
          "https://socialeagleacademy.in/B23 Brochure - Social Eagle Academy.pdf",
          "_blank"
        );
        download(
          "https://socialeagleacademy.in/B23 Brochure - Social Eagle Academy.pdf",
          "B23 Brochure - Social Eagle Academy.pdf"
        );
      } catch (error) {
        setLoading(false);
        console.error("Error writing to Google Sheets:", error);
      }
    } else {
      setLoading(false);
      setValidation(validate);
    }
  };

  const download = (path, filename) => {
    const anchor = document.createElement("a");
    anchor.href = path;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };
  const setFieldData = (e, key) => {
    setData({ ...data, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  return (
    <div>
      <CustomModal
        open={open}
        onClickOutside={() => {
          setClose(false);
          setValidation({});
        }}
      >
        <div className="modal-content contact-container w-50 m-auto rounded-3"
          style={{
            height: '80vh',
            overflow: 'hidden'
          }}
        >
          <iframe
            src="https://becomeaneagle.edgeone.app/?form=form_brochure-se-academy"
            style={{ width: '100%', height: '100%', border: 'none', paddingRight: 2 }}
            title="Brochure Download Form">
          </iframe>
        </div>
      </CustomModal>
      <ThankYouModal
        open={thankYouModal}
        setOpen={() => {
          setThankYouModal(false);
        }}
      />
    </div>
  );
};

export default BrochureDownloadModal;
